/**
 * Подпись о дырах в семидневной истории течений под усиками.
 *
 * Усик растёт назад по времени, поэтому сутки без течений гасят его молча:
 * частица «прилипает» на первом шаге назад, история схлопывается в точку, и на
 * карте просто пусто (регрессия 2026-08-07 — севернее 67° не было ни одного
 * усика при живом поле HSI и стрелках течений). Молчать об этом нельзя: снаружи
 * дыра неотличима от честного «вид тут не живёт».
 *
 * Докачку заводит ТОЛЬКО клик по «Загрузить/Обновить» (правка 17.08.2026): до
 * неё её ставил сам слой, а слой перезапрашивается от любого сдвига карты — под
 * кнопкой всплывала полоска «Докачка течений за 1 сутки… 18 %», которой никто не
 * заказывал. Поэтому у подписи две формы, и различает их не «есть ли дыра», а
 * «идёт ли работа»: пока никто не нажал — зовём нажать, пока задачи в очереди —
 * говорим, что докачка идёт (просить нажать ещё раз в это время бессмысленно,
 * повторную задачу на те же сутки очередь всё равно не примет).
 *
 * Обе функции возвращают КЛЮЧ каталога, а не фразу: решение «что сказать» — это
 * логика, а «как это звучит» — витрина. Единственное/множественное число суток
 * тоже больше не считается руками: `t(key, {count})` знает правила обоих языков.
 */
import { msg, type Msg } from '../i18n'

export interface HsiHistoryMeta {
  reason?: string | null
  missing_history_days?: string[] | null
}

export function hsiHistoryNote(
  meta: HsiHistoryMeta | null | undefined,
  { downloading = false }: { downloading?: boolean } = {},
): Msg | null {
  const days = meta?.missing_history_days
  if (!days || days.length === 0) return null
  return msg(
    downloading ? 'models.hsiDrift.historyGapQueued' : 'models.hsiDrift.historyGap',
    { count: days.length },
  )
}

/**
 * Подпись «почему усиков нет» — по причине из ответа.
 *
 * Пустая карта при включённом тумблере обязана объясняться. До 11.08.2026
 * единственной подписью была `hsiHistoryNote` (про дыры в течениях), и все
 * остальные причины молчали: кадр Чукотки с сельдью показывал градиент, «ниже
 * индекса 100» и чистую воду — при том, что поле вида там есть, просто целиком
 * помечено устаревшим после докачки течений.
 *
 * Ветки различаются по тому, ЧТО человеку делать:
 *  • `stale_hsi`/`no_hsi` — чинится расчётом, и он либо уже идёт, либо его
 *    закажет кнопка «Обновить»;
 *  • `empty_field` — поле свежее и нулевое, вид тут не живёт: предлагать
 *    пересчёт значит обещать результат, которого не будет;
 *  • `no_currents` — не хватает самих течений, расчёт HSI это не чинит.
 * Про дыры в истории говорит СВОЯ подпись — это другая беда и другое лечение,
 * поэтому обе могут стоять рядом.
 */
export function hsiDriftNote(
  meta: HsiHistoryMeta | null | undefined,
  { recomputing }: { recomputing: boolean },
): Msg | null {
  switch (meta?.reason) {
    case 'stale_hsi':
    case 'no_hsi':
      return recomputing
        ? msg('models.hsiDrift.empty.recomputing')
        : msg('models.hsiDrift.empty.stale')
    case 'empty_field':
      return msg('models.hsiDrift.empty.emptyField')
    case 'no_currents':
      return msg('models.hsiDrift.empty.noCurrents')
    default:
      return null
  }
}
